<script>
  /* global Global */
  import ColorStripeDefault from './ColorStripeDefault.svelte';
  import ColorStripeOld from './ColorStripeOld.svelte';

  const projectStyle = Global.project.style;
</script>

{#if projectStyle === 'old'}
  <ColorStripeOld/>
{:else}
  <ColorStripeDefault/>
{/if}
